import { IApplicationState } from '../../types/redux';

export const getNewReviewLoadingError = (state: IApplicationState): boolean => {
  return state.newReview.meta.loadingError;
};
